<template>
  <div class="flex">
    <!-- Backdrop -->
    <div
      :class="isOpen ? 'block' : 'hidden'"
      class="fixed inset-0 z-20 transition-opacity bg-black opacity-50 lg:hidden"
      @click="closeMenu()"

    />
    <!-- End Backdrop -->

    <div
      :class="isOpen ? 'translate-x-0 ease-out' : '-translate-x-full ease-in'"
      class="fixed inset-y-0 left-0 z-30 w-50 overflow-y-auto transition duration-300 transform bg-gray-900 lg:translate-x-0 lg:static lg:inset-0"
      style="background-color: #1a202c"
     >
      <div class="flex items-center justify-start px-5 mt-4">
        <div class="flex items-center">
          <img src="@/assets/logo.png" alt="logo" class="w-10 h-10 mr-2">
          <span class="mx-2 text-md font-semibold text-white">Colegio 5159</span>
        </div>
      </div>

      <nav class="mt-6">

        <!-- Option Home -->
        <router-link
          v-if="rolePermissions.find( x => x.name == 'home').roles.includes(currentUser.role)"
          class="flex items-center px-4 py-2 mt-2 duration-200 border-l-4"
          :class="[$route.name === 'Home' ? activeClass : inactiveClass]"
          to="/home"
          >
          <i class="fa-solid fa-house"></i>
          <span class="mx-3">Inicio</span>
        </router-link>

        <!-- Option Tasks -->
        <router-link
          v-if="rolePermissions.find( x => x.name == 'tasks').roles.includes(currentUser.role)"
          class="flex items-center px-4 py-2 mt-2 duration-200 border-l-4"
          :class="[$route.name === 'TasksView' ? activeClass : inactiveClass]"
          to="/tasks"
          >
          <i class="fa-solid fa-list"></i>
          <span class="mx-3">Tareas</span>
        </router-link>

         <!-- Option Eventos
         <router-link
          v-if="rolePermissions.find( x => x.name == 'eventos').roles.includes(currentUser.role)"
          class="flex items-center px-4 py-2 mt-2 duration-200 border-l-4"
          :class="[$route.name === 'EventosView' ? activeClass : inactiveClass]"
          to="/eventos"
          >
          <i class="fa-solid fa-calendar-days"></i>
          <span class="mx-3">Eventos</span>
        </router-link> -->


        <!-- Option Teacher -->
        <router-link
          v-if="rolePermissions.find( x => x.name == 'teacher').roles.includes(currentUser.role)"
          class="flex items-center px-4 py-2 mt-2 duration-200 border-l-4"
          :class="[$route.name === 'teachers' ? activeClass : inactiveClass]"
          to="/teachers"
          >
          <i class="fa-solid fa-chalkboard-user"></i>
          <span class="mx-3">Profesores</span>
        </router-link>

        <!-- Option Preceptores (student_assistant) -->
        <router-link
          v-if="rolePermissions.find( x => x.name == 'preceptores').roles.includes(currentUser.role)"
          class="flex items-center px-4 py-2 mt-2 duration-200 border-l-4"
          :class="[$route.name === 'PreceptoresView' || $route.name === 'createStudentAssistant' || $route.name === 'editStudentAssistant' ? activeClass : inactiveClass]"
          to="/preceptores"
          >
          <i class="fa-solid fa-user-graduate"></i>
          <span class="mx-3">Preceptores</span>
        </router-link>

        <!-- Option Conceptos -->
        <router-link
          v-if="rolePermissions.find( x => x.name == 'conceptos').roles.includes(currentUser.role)"
          class="flex items-center px-4 py-2 mt-2 duration-200 border-l-4"
          :class="[$route.name === 'ConceptosView' ? activeClass : inactiveClass]"
          to="/conceptos"
          >
          <i class="fa-solid fa-list"></i>
          <span class="mx-3">Conceptos</span>
        </router-link>

        <!-- Option Schedules -->
        <router-link
          v-if="rolePermissions.find( x => x.name == 'schedules').roles.includes(currentUser.role)"
          class="flex items-center px-4 py-2 mt-2 duration-200 border-l-4"
          :class="[$route.name === 'Dashboard' ? activeClass : inactiveClass]"
          to="/"
          >
          <i class="fa-solid fa-house"></i>
          <span class="mx-3">Horarios</span>
        </router-link>

        <!-- Option MySchedules -->
        <router-link
          v-if="rolePermissions.find( x => x.name == 'mySchedules').roles.includes(currentUser.role)"
          class="flex items-center px-4 py-2 mt-2 duration-200 border-l-4"
          :class="[$route.name === 'MySchedules' ? activeClass : inactiveClass]"
          to="/my-schedules"
          >
          <i class="fa-solid fa-calendar"></i>
          <span class="mx-3">Mi Horario</span>
        </router-link>

        <!-- Option Leave Management -->
        <router-link
          v-if="rolePermissions.find( x => x.name == 'leaveManagement').roles.includes(currentUser.role)"
          class="flex items-center px-4 py-2 mt-2 duration-200 border-l-4"
          :class="[$route.path.startsWith('/leave') ? activeClass : inactiveClass]"
          :to="leaveHomePath"
          >
          <i class="fa-solid fa-clipboard-list"></i>
          <span class="mx-3">Licencias</span>
        </router-link>

        <!-- Option RequestedVideos -->
        <router-link
          v-if="rolePermissions.find( x => x.name == 'requestedVideos').roles.includes(currentUser.role)"
          class="flex items-center px-4 py-2 mt-2 duration-200 border-l-4"
          :class="[$route.name === 'RequestedVideos' ? activeClass : inactiveClass]"
          to="/requested-videos"
          >
          <i class="fa-solid fa-video"></i>
          <span class="mx-3">Videos Solicitados</span>
        </router-link>

        <!-- Option Compensatorios -->
        <router-link
          v-if="rolePermissions.find( x => x.name == 'compensatorios').roles.includes(currentUser.role)"
          class="flex items-center px-4 py-2 mt-2 duration-200 border-l-4"
          :class="[$route.name === 'CompensatoriosView' ? activeClass : inactiveClass]"
          to="/compensatorios"
          >
          <i class="fa-solid fa-clock-rotate-left"></i>
          <span class="mx-3">Compensatorios</span>
        </router-link>

        <!-- Option Notificaciones (solo admin) -->
        <router-link
          v-if="rolePermissions.find( x => x.name == 'notifications').roles.includes(currentUser.role)"
          class="flex items-center px-4 py-2 mt-2 duration-200 border-l-4"
          :class="[$route.name === 'NotificationsAdminView' ? activeClass : inactiveClass]"
          to="/notificaciones"
          >
          <i class="fa-solid fa-bell"></i>
          <span class="mx-3">Notificaciones</span>
        </router-link>

        <!-- Option Noticias (admin y director) -->
        <router-link
          v-if="rolePermissions.find( x => x.name == 'noticias').roles.includes(currentUser.role)"
          class="flex items-center px-4 py-2 mt-2 duration-200 border-l-4"
          :class="[$route.path.startsWith('/noticias') ? activeClass : inactiveClass]"
          to="/noticias"
          >
          <i class="fa-solid fa-newspaper"></i>
          <span class="mx-3">Noticias</span>
        </router-link>

        <!-- Option VideoTutorials -->
        <router-link
          class="flex items-center px-4 py-2 mt-2 duration-200 border-l-4"
          :class="[$route.name === 'VideoTutorialsView' ? activeClass : inactiveClass]"
          to="/video-tutorials"
          >
          <i class="fa-solid fa-video"></i>
          <span class="mx-3">Video Tutoriales</span>
        </router-link>

        <!-- Option Post -->
        <!-- <router-link
          class="flex items-center px-6 py-2 mt-4 duration-200 border-l-4"
          :class="[$route.name === 'post' ? activeClass : inactiveClass]"
          to="/posts"
          >
          <i class="fa-solid fa-pen-to-square"></i>
          <span class="mx-4">Publicaciones</span>
        </router-link> -->

        <!-- Option Users -->
        <!-- <router-link
          class="flex items-center px-6 py-2 mt-4 duration-200 border-l-4"
          :class="[$route.name === 'Configuration' ? activeClass : inactiveClass]"
          to="/users"
          >
          <i class="fa-solid fa-users"></i>
          <span class="mx-4">Usuarios</span>
        </router-link> -->

        <!-- Option Configurations -->
        <!-- <router-link
          class="flex items-center px-4 py-2 mt-2 duration-200 border-l-4"
          :class="[$route.name === 'Configuration' ? activeClass : inactiveClass]"
          to="/configurations"
          >
          <i class="fa-solid fa-gear"></i>
          <span class="mx-3">Configuraciones</span>
        </router-link> -->

      </nav>
    </div>
  </div>
</template>
<script>
import {  mapGetters } from 'vuex'


export default {
  props: {
    isOpen: Boolean,
    width: String,
  },



  data(){
    return{
        rolePermissions: [
          {name: 'teacher', roles: ['admin', 'administrative', 'executive', 'director', 'student_assistant']},
          {name: 'preceptores', roles: ['admin', 'administrative', 'executive', 'director']},
          {name: 'tasks', roles: ['admin', 'teacher', 'executive', 'administrative', 'director', 'student_assistant']},
          {name: 'conceptos', roles: ['admin', 'teacher',  'executive', 'director', 'rti', 'student_assistant']},
          {name: 'schedules', roles: ['admin', 'administrative', 'executive', 'director']},
          {name: 'home', roles: ['teacher', 'admin', 'student_assistant']},
          {name: 'mySchedules', roles: ['teacher']},
          {name: 'leaveManagement', roles: ['teacher', 'admin', 'executive', 'director', 'administrative']},
          {name: 'requestedVideos', roles: ['teacher', 'executive', 'admin']},
          {name: 'eventos', roles: ['teacher', 'executive', 'admin', 'administrative', 'director']},
          {name: 'compensatorios', roles: ['executive', 'admin','administrative', 'director']},
          {name: 'notifications', roles: ['admin']},
          {name: 'noticias', roles: ['admin', 'director']},
        ],
        activeClass: 'bg-gray-600 bg-opacity-25 text-gray-100 border-gray-100',
        inactiveClass: 'border-gray-900 text-gray-500 hover:bg-gray-600 hover:bg-opacity-25 hover:text-gray-100',

    }
  },
  computed: {
        ...mapGetters('authentication', ['currentUser']),
        leaveHomePath() {
          return ['admin', 'executive', 'director', 'administrative'].includes(this.currentUser?.role)
            ? '/leave/inbox'
            : '/leave/requests';
        }
    },
  watch: {
    $route() {
      // Cerrar el menú cuando cambia la ruta (útil en móvil)
      if (this.isOpen) {
        this.closeMenu();
      }
    }
  },
  methods: {
     closeMenu() {

      this.$emit('update:isOpen', false);
    }
  },


}
</script>

<style>

</style>